var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon icon--chevron-right",attrs:{"width":"7","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1.3 0L0 1.3l4.3 4.2L0 9.7 1.3 11 7 5.5 1.3 0z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }